import { render } from "./PusakaList.vue?vue&type=template&id=11825152&scoped=true"
import script from "./PusakaList.vue?vue&type=script&lang=js"
export * from "./PusakaList.vue?vue&type=script&lang=js"

import "./PusakaList.vue?vue&type=style&index=0&id=11825152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11825152"]])

export default __exports__